import { render, staticRenderFns } from "./HomeSidebar.vue?vue&type=template&id=456cd6b6&scoped=true&"
import script from "./HomeSidebar.vue?vue&type=script&setup=true&lang=js&"
export * from "./HomeSidebar.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "456cd6b6",
  null
  
)

export default component.exports